export enum State {
  'init',
  'pending',
  'fulfilled',
  'error',
  'deleting',
  'saving',
}
